import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {DocumentActions, FEATURE} from '../../redux/actions/documents';
import {CommandActions as DocumentCommandActions} from '../../redux/actions/document';
import {CommandActions as DocumentsCommandActions, DocumentActions as DocumentDocumentsActions} from '../../redux/actions/documents';
import {CommandActions as ModalCommandActions} from '../../redux/actions/modal';
import {CommandActions as FiltersCommandActions} from '../../redux/actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import CommandBar from './command_bar/index'
import Notification from '../notification/index';
import { getNotification } from '../../redux/selectors/notification';
import { getFilterPanelOpened } from '../../redux/reducers/ui';
import { getLoader } from '../../redux/selectors/loader';
import { IColumn, MessageBarType, ProgressIndicator, Spinner, SpinnerSize, Selection } from '@fluentui/react';
import { getClassNames } from './index.classNames';
import { getColumns } from '../documents/columns';
import SelectedFilters from '../filtersPanel/filters/selectedFilters';
import _ from 'lodash';
import { getOrderColumn, getTotal } from '../../redux/reducers/documents';
import DocumentModal from '../modals/document'
import DocumentsGrid from '../documents/index'
import { getSelectedProjectUserActions } from '../../redux/selectors/auth';
import { getFilters } from '../../redux/reducers/filters';
import { Filters } from '../../models/filters';
import { getGenericModal, getNotificationWidth } from '../../redux/selectors/ui';
import CalloutFilters from '../filtersPanel/callout/index';
import { MainCompGenerator as GenericModalGenerator, Actions as GenericModalActions } from '@pwbapps/genericdialog'
import DownloadComments from '../documents/functionalities/downloadComments';
import SelectLanguage from '../documents/functionalities/selectLanguage';
import SelectFileType from '../documents/functionalities/selectFileType';
import DownloadExcelReport from '../documents/functionalities/downloadExcelReport';
import { InternalRoleActionsType, ExternalRoleActionsType, isExternalApp, getTheme } from '../../utils/costants';
import { getHistoryName } from '../../utils/functions';
import { getContextualDocuments } from '../../redux/selectors/documents';
import { Document, FileForm } from '../../models/document';
import { Status } from '../../models/status';
import UploadParentFile from '../documents/functionalities/uploadParentFileSupplier';
import ImportZip from '../documents/functionalities/importZip';
import ReserveNumberSupplier from '../documents/functionalities/reserveNumberSupplier';
import { Type } from '../../models/type';
import { withTranslation, WithTranslation  } from 'react-i18next';
import { getEmail } from '@pwbapps/reduxcore/dist/redux/reducers/auth';
import { getDarkModeEnabled } from '../../redux/reducers/project';
import GenerateNumbAndPart from '../documents/functionalities/generateNumbAndPart';
let GenericModal = GenericModalGenerator();

export interface ReservedNumbersProps extends RouteComponentProps, WithTranslation {
    loading: boolean,
    loadingContent: boolean,
    loadingScroll: boolean,
    documents: Document[]
    filterPanelOpened: boolean, 
    showNotification: boolean, 
    type: MessageBarType, 
    message: string,
    userProjectActions: InternalRoleActionsType[] | ExternalRoleActionsType[],
    filters: Filters,
    showCallout: boolean,
    orderColumn: {name: string, direction: string },
    total: number,
    changeStatusForm?: {
        newStatus: Status,
        fileForm?: FileForm,
        files?: any[]
    },
    notificationWidth: string,
    email?: string,
    darkModeEnabled: boolean,
    isNewLanguage: boolean,
    isNewFileType: boolean,
    setSelectedItemsIds: typeof DocumentActions.setSelectedItemsIds,
    getDocumentAndOpenModal: typeof DocumentCommandActions.getDocumentAndOpenModal,
    showOrHideCallout: typeof FiltersCommandActions.showOrHideCallout,
    openGenericModal: typeof ModalCommandActions.openModal,
    closeGenericModal: typeof ModalCommandActions.closeModal,
    downloadOrShowFile: typeof DocumentsCommandActions.downloadOrShowFile,
    fetchDocuments: typeof DocumentsCommandActions.fetchDocuments,
    setSortColumn: typeof DocumentDocumentsActions.setSortColumn,
    downloadComments: typeof DocumentsCommandActions.downloadComments,
    downloadExcelReport: typeof DocumentsCommandActions.downloadExcelReport,
    downloadTemplate: typeof DocumentsCommandActions.downloadTemplate,
    uploadSupplierFile: typeof DocumentsCommandActions.uploadSupplierFile,
    newRevision: typeof DocumentsCommandActions.newRevision,
    newSheet: typeof DocumentsCommandActions.newSheet
    selectLanguage: typeof DocumentsCommandActions.selectLanguage,
    selectFileType: typeof DocumentsCommandActions.selectFileType,
    newLanguage: typeof DocumentsCommandActions.newLanguage,
    newFileType: typeof DocumentsCommandActions.newFileType,
    saveNumberAndPart: typeof DocumentsCommandActions.saveNumberAndPart,
    
}
class ReservedNumbers extends React.Component<ReservedNumbersProps & RouteComponentProps> {
    constructor(props: ReservedNumbersProps) {
        super(props);   
    }

    getKey = (item: any, index?: number): string => {
        return item.id;
    }

    getFilters = (): Filters => {
        const { filters } = this.props;
        return filters;
    }

    getFilterPanel = (): boolean => {
        const { filterPanelOpened } = this.props;
        return filterPanelOpened;
    }

    onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { fetchDocuments, setSortColumn } = this.props; 
        setSortColumn({colName: column.fieldName as string, direction: (column.isSortedDescending) ? 'asc' : 'desc', feature: FEATURE});
        //this.selection.setAllSelected(false);    
        fetchDocuments({});
    };

    selection = new Selection({		
        getKey: this.getKey,
		onSelectionChanged: () => {
            let rows = this.selection.getSelection() as any;
            const {setSelectedItemsIds} = this.props;
            let ids = (rows) ? _.map(rows, (r: Document) => {return r.id as number}) : [];
            setSelectedItemsIds({ids: _.map(ids, id => id.toString()), feature: FEATURE}) 
		}
    });

    render(){
        const {loading, loadingContent, showNotification, type, message, filterPanelOpened, orderColumn, loadingScroll, userProjectActions, documents, notificationWidth, t, email, darkModeEnabled,
               history, isNewLanguage, isNewFileType,
               getDocumentAndOpenModal, showOrHideCallout, closeGenericModal, downloadOrShowFile, openGenericModal, uploadSupplierFile, selectLanguage, selectFileType, saveNumberAndPart,
               downloadComments, downloadExcelReport, newSheet, newRevision, newFileType, newLanguage} = this.props;
        const styles = getClassNames(filterPanelOpened);
        const historyName = getHistoryName(history);
        const canRead = _.find(userProjectActions, a => a === 'ReadReservedNumbers') ? true : false;
        const canUploadParent = _.find(userProjectActions, a => a === 'UploadParentReservedNumbers') ? true : false;
        const columns = getColumns(email as string, t, canRead, false, this.selection, this.getFilterPanel, getDocumentAndOpenModal, this.getFilters, showOrHideCallout, downloadOrShowFile, this.onColumnClick, orderColumn, historyName, openGenericModal, canUploadParent, undefined, _.some(userProjectActions, a => a === 'FilterDocumentsByPartnerId'), getTheme(darkModeEnabled));
        const singleSelectedDocument = (documents && documents.length === 1) ? documents[0] : undefined;
        return (
            <>
                <CommandBar userProjectActions={userProjectActions} loading={loading} loadingContent={loadingContent} loadingScroll={loadingScroll}/>
                <div style={{position: 'absolute', width: notificationWidth, top: 99, zIndex: 10}}>
                    {!loading && !loadingContent && <Notification name={'reservedNumbers'} show={showNotification} type={type} message={message}/>}
                </div>
                <SelectedFilters/>
                <ProgressIndicator styles={{root: {height: 10}}} progressHidden={ !loadingContent || loading }/> 
                {loading && <Spinner size={SpinnerSize.large} style={{marginTop: 50}}></Spinner>}
                {!loading &&
                    <div className={styles.resultContainer}>
                        <DocumentsGrid selection={this.selection} columns={columns} loadingScroll={loadingScroll}/>
                        <DocumentModal userProjectActions={userProjectActions}/>
                    </div>
                }
                <CalloutFilters/>

                {singleSelectedDocument && 
                    <GenericModal 
                        id={'uploadParent'}
                        title={t('Upload file')}
                        message={''}                 
                        onClose={() => {closeGenericModal({id: 'uploadParent'})}}
                        btnCloseText={t('Cancel')}
                        onConfirm={() => {uploadSupplierFile()}}
                        btnConfirmText={t('Save')}
                        customComponent={<UploadParentFile loadingContent={loadingContent} type={singleSelectedDocument.type as Type}/>}
                        disableAutoModalClose 
                        disableClose={loadingContent}    
                        width={720}    
                    />      
                }
                <GenericModal 
                    id={'importZip'}
                    title={t('Import ZIP file')}
                    message={''}                 
                    onClose={() => {closeGenericModal({id: 'importZip'})}}
                    btnCloseText={t('Cancel')}
                    customComponent={<ImportZip loadingContent={loadingContent}/>}
                    disableAutoModalClose 
                    disableClose={loadingContent}        
                />   
                <GenericModal 
                    id={'comments'}
                    title={t('Download comments')}
                    message={''}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadComments()}}
                    btnConfirmText={t('Download')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadComments/>}
                    disableConfirm={loadingContent}     
                />
                <GenericModal 
                    id={'excelReport'}
                    title={t('Download Excel report')}
                    message={''}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadExcelReport()}}
                    btnConfirmText={t('Download')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadExcelReport/>}
                    disableConfirm={loadingContent}          
                />
                <GenericModal 
                    id={'selectLanguage'}
                    title={t('Language selection')}
                    message={''}                 
                    onClose={() => {}}
                    onConfirm={() => {(!isNewLanguage) ? selectLanguage() : newLanguage()}}
                    btnConfirmText={t('Save')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<SelectLanguage/>}
                    disableConfirm={loadingContent} 
                    width={580}    
                />
                {_.some(userProjectActions, a => a === 'NewSheetReservedNumbers') && 
                    <GenericModal 
                        id={'sheet'}
                        title={t('New sheet')}
                        message={t('Do you want to add a new sheet to these documents?')}              
                        onClose={() => {}}
                        onConfirm={() => {newSheet()}}
                        btnConfirmText={t('Save')}
                        btnCloseText={t('Cancel')}   
                        disableConfirm={loadingContent}    
                    />
                }
                {_.some(userProjectActions, a => a === 'NewRevisionReservedNumbers') && 
                    <GenericModal 
                        id={'revision'}
                        title={t('New revision')}
                        message={t('Do you want to create a new revision for these documents?')}                 
                        onClose={() => {}}
                        onConfirm={() => {newRevision()}}
                        btnConfirmText={t('Yes')}
                        btnCloseText={t('No')}   
                        disableConfirm={loadingContent}    
                    />
                }
                {_.some(userProjectActions, a => a === 'SelectFileTypeReservedNumbers') && 
                    <GenericModal 
                        id={'selectFileType'}
                        title={t('Select file type')}
                        message={''}                 
                        onClose={() => {}}
                        onConfirm={() => {(!isNewFileType) ? selectFileType() : newFileType()}}
                        btnConfirmText={t('Save')}
                        btnCloseText={t('Cancel')}   
                        customComponent={<SelectFileType/>}
                        disableConfirm={loadingContent} 
                        width={580}       
                    />
                }
                { !isExternalApp &&
                    <GenericModal 
                        id={'reserveNumberSupplier'}
                        title={t('Reserve number')}
                        message={''}                 
                        onClose={() => {closeGenericModal({id: 'reserveNumberSupplier'})}}
                        btnCloseText={t('Cancel')}
                        customComponent={<ReserveNumberSupplier loadingContent={loadingContent}/>}
                        disableAutoModalClose 
                        disableClose={loadingContent}        
                    />   
                }
                {_.some(userProjectActions, a => a === 'GenerateNumberAndPartReservedNumbers') && 
                    <GenericModal 
                        id={'generateNumbAndPart'}
                        title={t('Generate number and part')}
                        message={''}                 
                        onClose={() => {}}
                        onConfirm={() => {saveNumberAndPart()}}
                        btnConfirmText={t('Save')}
                        btnCloseText={t('Cancel')}   
                        customComponent={<GenerateNumbAndPart/>}
                        disableConfirm={loadingContent} 
                        width={640}       
                    />
                }
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    loading: (state) => getLoader('reservedNumbers')(state).loading,
    loadingContent: (state) => getLoader('reservedNumbers')(state).loadingContent,
    loadingScroll: (state) => getLoader('reservedNumbers')(state).loadingScroll,
    showNotification: (state) => getNotification('reservedNumbers')(state).show,
    type: (state) => getNotification('reservedNumbers')(state).type,
    message: (state) => getNotification('reservedNumbers')(state).message,
    filterPanelOpened: getFilterPanelOpened,
    userProjectActions: getSelectedProjectUserActions,
    filters: getFilters,
    orderColumn: getOrderColumn,
    total: getTotal,
    documents : getContextualDocuments,
    notificationWidth: getNotificationWidth,
    email: getEmail,
    darkModeEnabled: getDarkModeEnabled,
    isNewLanguage: (state) => (getGenericModal('selectLanguage')(state)) ? (getGenericModal('selectLanguage')(state) as any).optional as boolean : false,
    isNewFileType: (state) => (getGenericModal('selectFileType')(state)) ? (getGenericModal('selectFileType')(state) as any).optional as boolean : false,
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setSelectedItemsIds: DocumentActions.setSelectedItemsIds,
        getDocumentAndOpenModal: DocumentCommandActions.getDocumentAndOpenModal,
        showOrHideCallout: FiltersCommandActions.showOrHideCallout,
        openGenericModal: ModalCommandActions.openModal,
        closeGenericModal: ModalCommandActions.closeModal,
        downloadOrShowFile: DocumentsCommandActions.downloadOrShowFile,
        fetchDocuments: DocumentsCommandActions.fetchDocuments,
        setSortColumn: DocumentDocumentsActions.setSortColumn,
        downloadComments: DocumentsCommandActions.downloadComments,
        downloadExcelReport: DocumentsCommandActions.downloadExcelReport,
        downloadTemplate: DocumentsCommandActions.downloadTemplate,
        uploadSupplierFile: DocumentsCommandActions.uploadSupplierFile,
        newRevision: DocumentsCommandActions.newRevision,
        newSheet: DocumentsCommandActions.newSheet,
        selectLanguage: DocumentsCommandActions.selectLanguage,
        selectFileType: DocumentsCommandActions.selectFileType,
        newLanguage: DocumentsCommandActions.newLanguage,
        newFileType: DocumentsCommandActions.newFileType,
        saveNumberAndPart: DocumentsCommandActions.saveNumberAndPart
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()(withRouter(ReservedNumbers)));